const initialState = "default";

/**
 * selectPartReducer: Reducer to manage the state for the selected part.
 * @param {any} state - The current state of the selected part.
 * @param {any} action - The action to be processed.
 * @returns {any} - The updated state based on the action type.
 */
const selectPartReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_SELECTED_PART":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default selectPartReducer;
